import React from 'react';

const CustomerMissedCallNotification = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="36" height="36" rx="18" fill="#FFE9E9" />
      <mask
        id="mask0_975_1972"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="8"
        width="20"
        height="20"
      >
        <rect x="8" y="8" width="20" height="20" fill="#EC5962" />
      </mask>
      <g mask="url(#mask0_975_1972)">
        <path
          d="M18.0215 18C19.7576 18 21.4104 18.3439 22.9798 19.0317C24.5493 19.7189 25.9243 20.6944 27.1048 21.9583C27.2576 22.1111 27.334 22.3056 27.334 22.5417C27.334 22.7778 27.2576 22.9722 27.1048 23.125L25.1882 25C25.0354 25.1528 24.8584 25.2361 24.6573 25.25C24.4557 25.2639 24.2715 25.2083 24.1048 25.0833L21.3548 23V20.2083C20.8132 20.0278 20.2645 19.8922 19.709 19.8017C19.1534 19.7117 18.5909 19.6667 18.0215 19.6667C17.452 19.6667 16.8895 19.7117 16.334 19.8017C15.7784 19.8922 15.2298 20.0278 14.6882 20.2083V23L11.9382 25.0833C11.7715 25.2083 11.5873 25.2639 11.3857 25.25C11.1845 25.2361 11.0076 25.1528 10.8548 25L8.93815 23.125C8.78537 22.9722 8.70898 22.7778 8.70898 22.5417C8.70898 22.3056 8.78537 22.1111 8.93815 21.9583C10.1187 20.6806 11.4937 19.7014 13.0632 19.0208C14.6326 18.3403 16.2854 18 18.0215 18ZM18.0007 17.5L13.8757 13.375V15.5417H12.209V10.5417H17.209V12.2083H15.0423L17.9798 15.1458L22.6882 10.4375L23.8756 11.625L18.0007 17.5Z"
          fill="#EC5962"
        />
      </g>
    </svg>
  );
};

export default CustomerMissedCallNotification;
